import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { getAllRegionSettings,getAlarmFields,updateAlarmFieldFunc, getPredefinedTextListFunc } from '../action/alarmFieldsAction';
import AlarmFieldsComponent from '../components/alarmFieldsComponent';

export class AlarmFieldsContainer extends Component{
    constructor(props){
        super(props)
    }
    componentDidMount(){
        //this.props.actions.getAlarmFields();
        //this.props.actions.getPredefinedTextListFunc();
        this.props.actions.getAllRegionSettings();
    }
    getUserList = (data) =>{
                        this.props.actions.getAlarmFields(data,
                            this.props.dispatch
                        )
                    }
    getSMTPdata = () =>{
        this.props.actions.getAlarmStatusColorList(
            this.props.dispatch
        )
    }
    
    updateAlarmField = (payload) =>{
        this.props.actions.updateAlarmFieldFunc(
            payload,
            this.props.dispatch
        )
    }
     getRegionData = () => {
                         this.props.actions.getAllRegionSettings(this.props.dispatch);
                      } 
    render(){
        return(
            <AlarmFieldsComponent
            updateAlarmField = {this.updateAlarmField}
            getAllAlarmStatusData = {this.props.alarmStatusData}
               getRegionList={this.getRegionData}
                    getUserList ={this.getUserList}
            // getSMTPdata = {this.getSMTPdata}
            >
            </AlarmFieldsComponent>
        )
    }
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch: dispatch,
        actions: bindActionCreators({
            getAlarmFields,
            updateAlarmFieldFunc,
            getPredefinedTextListFunc,
            getAllRegionSettings
        },
            dispatch)
    };
}
function mapStateToProps({ AlarmFieldsReducer }) {
    console.log(AlarmFieldsReducer);
    return {
        alarmStatusData : {
            errorCode : AlarmFieldsReducer.errorCode,
            statusCode : AlarmFieldsReducer.statusCode,
            alarmDataList : AlarmFieldsReducer.alarmDataList,
            message : AlarmFieldsReducer.message,
            isLoading : AlarmFieldsReducer.isLoading,
            predefinedTextList : AlarmFieldsReducer.predefinedTextList,
            regionList : AlarmFieldsReducer.regionList,
        }
    }
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AlarmFieldsContainer));
